<template>
  <div class="card-block-evaluation">
    <ul>
      <li v-for="(item, index) in data" :key="index" :class="isTextWeightMedium(item)" :data-cy="`item-summary-${index}`">
        {{ item.label }}
        <span class="is-pulled-right" :data-cy="`item-summary-${index}-value`">
          {{ item.value }}
          <b-icon v-if="item.icon" class="evaluation-icon" :icon="item.icon.icon" :type="item.icon.type" />
        </span>
        <ul v-if="item.children">
          <li v-for="(child, i) in item.children" :key="i" :data-cy="`sub-item-summary-${index}`">
            {{ child.label }}
            <span class="is-pulled-right" :data-cy="`item-summary-${index}-value`">
              {{ child.value }}
            </span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EvaluationSummaryItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    isTextWeightMedium(item) {
      return item.isBold ? 'has-text-weight-medium' : '';
    }
  }
};
</script>

<style scoped>
ul li {
  padding: 5px 0;
}
ul li,
ul ul li:first-child {
  border-top: 1px solid #E9E9E9;
}
ul li:first-child {
  border-top: none;
}
ul li.has-text-weight-medium li {
  font-weight: normal;
}
ul ul li {
  padding: 5px 0 5px 25px;
}
.card-block-evaluation {
  border: 1px solid #E9E9E9;
  border-radius: 10px;
  padding: 5px 15px;
  font-size: 0.875rem;
}
.evaluation-icon {
  font-size: 0.875rem;
}
</style>
